module.exports = __webpack_public_path__ + "img/Ecuador.bc30fdb6.svg";